/** Enable with localStorage.setItem('shm_video_debug', '1') in browser console */
export const isVideoDebugEnabled = () =>
  process.env.NODE_ENV === 'development'
  || (typeof localStorage !== 'undefined' && localStorage.getItem('shm_video_debug') === '1');

export const logVideo = (label, payload) => {
  if (!isVideoDebugEnabled()) return;
  console.groupCollapsed(`[SHM Video] ${label}`);
  console.log(payload);
  console.groupEnd();
};

export const resolveVideoId = (video) => video?._id || video?.id || null;

export const summarizeVideo = (video) => ({
  id: resolveVideoId(video),
  type: video?.type,
  videoLabel: video?.videoLabel,
  dataLoggerSerialNo: video?.dataLoggerSerialNo,
  recordedAt: video?.recordedAt,
  filename: video?.filename,
});

export const diagnoseVideoFilters = ({
  rawEventVideos,
  rawHealthVideos,
  selectedDataLoggerSerial,
  startDate,
  endDate,
}) => {
  const filterByLogger = (videos) => (
    selectedDataLoggerSerial
      ? videos.filter((v) => v.dataLoggerSerialNo === selectedDataLoggerSerial)
      : videos
  );

  const afterLoggerEvent = filterByLogger(rawEventVideos);
  const afterLoggerHealth = filterByLogger(rawHealthVideos);

  const loggerMismatchEvent = rawEventVideos.filter(
    (v) => selectedDataLoggerSerial && v.dataLoggerSerialNo !== selectedDataLoggerSerial
  );
  const loggerMismatchHealth = rawHealthVideos.filter(
    (v) => selectedDataLoggerSerial && v.dataLoggerSerialNo !== selectedDataLoggerSerial
  );

  const wrongTypeInEvent = rawEventVideos.filter(
    (v) => v.type !== 'event' || v.videoLabel === 'keep_alive'
  );

  const outOfRange = (videos) => videos.filter((v) => {
    if (!v.recordedAt || !startDate || !endDate) return false;
    const t = new Date(v.recordedAt).getTime();
    const start = new Date(`${startDate}T00:00:00.000Z`).getTime();
    const end = new Date(`${endDate}T23:59:59.999Z`).getTime();
    return t < start || t > end;
  });

  return {
    selectedDataLoggerSerial,
    dateFilter: startDate && endDate ? { start: startDate, end: endDate } : 'none (all indexed videos)',
    rawCounts: { event: rawEventVideos.length, health: rawHealthVideos.length },
    afterLoggerFilter: { event: afterLoggerEvent.length, health: afterLoggerHealth.length },
    droppedByLoggerMismatch: {
      event: loggerMismatchEvent.length,
      health: loggerMismatchHealth.length,
      sampleEventSerials: [...new Set(loggerMismatchEvent.map((v) => v.dataLoggerSerialNo))].slice(0, 5),
      sampleHealthSerials: [...new Set(loggerMismatchHealth.map((v) => v.dataLoggerSerialNo))].slice(0, 5),
    },
    droppedByTypeInEventEndpoint: wrongTypeInEvent.length,
    missingId: {
      event: rawEventVideos.filter((v) => !resolveVideoId(v)).length,
      health: rawHealthVideos.filter((v) => !resolveVideoId(v)).length,
    },
    possiblyOutOfRange: {
      event: outOfRange(rawEventVideos).length,
      health: outOfRange(rawHealthVideos).length,
      sampleDates: outOfRange(rawEventVideos).slice(0, 3).map((v) => v.recordedAt),
    },
    sampleEvent: rawEventVideos.slice(0, 2).map(summarizeVideo),
    sampleHealth: rawHealthVideos.slice(0, 2).map(summarizeVideo),
  };
};
